import { useT } from '../i18n';
import './TabFilters.css';

export const TabFilters = ({ tabs, activeTab, onChange, showAllTab = true }) => {
  const { t } = useT();
  // Group consecutive child tabs (the expanded sub-scopes) into a single
  // rounded grey container, so scope pills sit spaced apart on their own.
  const items = [];
  for (let i = 0; i < tabs.length; i++) {
    if (tabs[i].isChild) {
      const group = [];
      while (i < tabs.length && tabs[i].isChild) {
        group.push(tabs[i]);
        i++;
      }
      i--; // step back; the for-loop will increment
      items.push({ type: 'group', children: group });
    } else {
      items.push({ type: 'button', tab: tabs[i] });
    }
  }

  return (
    <div className="tab-filters">
      <div className="tab-filters-container">
        {items.map((item, idx) => {
          if (item.type === 'group') {
            return (
              <div key={`group-${idx}`} className="tab-child-group">
                {item.children.map((child) => (
                  <button
                    key={child.id}
                    className={`tab-filter-button child-tab ${activeTab === child.id ? 'active' : ''}`}
                    onClick={() => onChange(child.id)}
                  >
                    {child.label}
                  </button>
                ))}
              </div>
            );
          }
          const tab = item.tab;
          return (
            <button
              key={tab.id}
              className={`tab-filter-button ${activeTab === tab.id ? 'active' : ''} ${tab.isParent ? 'parent-tab' : ''}`}
              onClick={() => onChange(tab.id)}
            >
              {tab.label}
            </button>
          );
        })}
        {showAllTab && (
          <button
            className={`tab-filter-button all-tab ${activeTab === 'all' ? 'active' : ''}`}
            onClick={() => onChange('all')}
          >
            {t('tabf.all')}
          </button>
        )}
      </div>
    </div>
  );
};
